import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';

import FormInput from '../../../../components/atoms/FormInput';
import SubmitButton from '../../../../components/atoms/SubmitButton';
import ClientLabel from '../../atoms/ClientLabel';

const RowWrapper = styled(Row)`
  margin-top: 20px;
`;

const ClientInput = (props) => {
  const {
    input,
    button,
    label,
  } = props;

  return (
    <RowWrapper>
      <Col xs="auto">
        <FormInput
          onChange={input.onChange}
          name={input.name}
          value={input.value}
          placeHolder={input.placeHolder}
        />
      </Col>
      <Col sm="auto">
        <SubmitButton label={button.label} onClick={button.onClick} />
      </Col>
      <Col sm="auto" className="align-self-end">
        <ClientLabel label={label.value} />
      </Col>
    </RowWrapper>
  );
};

export default ClientInput;

ClientInput.propTypes = {
  input: PropTypes.shape({
    onChange: PropTypes.func.isRequired,
    name: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    placeHolder: PropTypes.string.isRequired,
  }).isRequired,
  button: PropTypes.shape({
    label: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
  }).isRequired,
  label: PropTypes.shape({
    value: PropTypes.string,
  }),
};

ClientInput.defaultProps = {
  label: {
    value: '',
  },
};
